import { Box } from "@mui/material";
import { useLocation, useSearchParams } from "react-router-dom"; // ✅ ADD THIS
import { useLazyGetSpecificTournamentQuery } from "../../services/tournamentsAPI";
import { getUserPref } from "../../uttils/UserPref";
import { useEffect, useState } from "react";
import TournamentHeader from "./TournamentHeader";
import CustomTabs from "./CustomTabs";
import AuctionInfo from "./AuctionInfo";
import AuctionTeams from "./AuctionTeams";
import AuctionPlayers from "./AuctionPlayers";
import SearchBar from "../../components/SearchInput";
import Loader from "../../components/Loader";

const AuctionDetails = () => {
  const location = useLocation(); // ✅ READ NAVIGATION STATE
  const userData = getUserPref();
  const { tournamentId } = JSON.parse(userData);
  const [searchParams, setSearchParams] = useSearchParams();
  const initialTab = Number(searchParams.get("tab") || 0); // ✅ TAKE TAB FROM STATE
  const [tab, setTab] = useState(initialTab); // ✅ SET TAB FROM STATE
  const [search, setSearch] = useState("");

  const [triggerGetTournament, { data, error, isLoading }] =
    useLazyGetSpecificTournamentQuery();

  useEffect(() => {
    if (tournamentId) {
      triggerGetTournament({ tournamentId });
    }
  }, [tournamentId, triggerGetTournament]);

  const tournamentData = data?.data?.tournament;

  useEffect(() => {
    setSearchParams({ tab });
  }, [tab]);

  if (isLoading) return <Loader />;
  if (error) return <p>Error loading tournament</p>;

  return (
    <Box sx={{ paddingTop: "2rem", overflowY: "scroll" }}>
      <TournamentHeader data={tournamentData} />

      {/* Tabs + Search Row */}
      <Box
        sx={{
          position: "relative",
          display: "flex",
          alignItems: "center",
          mt: 2,
          mb: 2,
          minHeight: "48px",
        }}
      >
        {/* Centered Tabs */}
        <Box
          sx={{
            position: "absolute",
            left: "50%",
            transform: "translateX(-50%)",
          }}
        >
          <CustomTabs
            value={tab}
            setValue={setTab}
            arr={["Auction Overview", "Teams", "Players"]}
          />
        </Box>

        {/* Right Aligned Search */}
        {(tab === 1 || tab === 2) && (
          <Box sx={{ marginLeft: "auto", width: "350px", paddingRight: "20px" }}>
            <SearchBar
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </Box>
        )}
      </Box>


      {tab === 0 ? (
        <AuctionInfo data={tournamentData} />
      ) : tab === 1 ? (
        <AuctionTeams data={tournamentData} search={search} />
      ) : tab === 2 ? (
        <AuctionPlayers data={tournamentData} search={search} />
      ) : null}
    </Box>
  );
};

export default AuctionDetails;
